
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Domain({domain, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{domain?.lib}</td>
            <td>de type {domain?.type}</td>
            <td>{domain?.nomtab}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (domain?.etat === 1) ? 'badge-warning' :
                        (domain?.etat === 2) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {domain?.etatdef}
                </div>
            </td>
            <td>{domain.datecrea ? <ReactTimeAgo date={Date.parse(domain?.datecrea)} timeStyle="facebook" /> : "No date found"}</td>
            <td className="text-center">
                <Link to={`/domain/${domain?.code}`} data-toggle="tooltip" title="consulter le domaine" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}